import {
  breakpoints,
  colors,
  cssfonts,
  pxToCssFont,
  pxToLineHeight,
  pxToRem,
} from '@vfit/shared/themes';
import styled from 'styled-components';

export const Article = styled.article<{ centerEditorialFrame?: boolean }>`
  padding: ${pxToRem(32, 24)};
  background-color: ${colors.$ffffff};
  border: 1px solid ${colors.$bebebe};
  border-radius: 20px;
  height: 100%;
  width: 269px;
  ${({ centerEditorialFrame }) => (centerEditorialFrame ? 'margin: 0 auto' : '')};

  @media (min-width: ${breakpoints.tablet}) {
    width: 328px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    width: 404px;
  }
`;

export const Title = styled.h3`
  ${cssfonts.exbold};
  ${pxToCssFont(24, 28)};
  margin: 0;

  @media (min-width: ${breakpoints.tablet}) {
    line-height: ${pxToLineHeight(24, 30)};
  }

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 45)};
  }
`;
